import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-upload-data-confirm',
  templateUrl: './upload-data-confirm.component.html',
  styleUrls: ['./upload-data-confirm.component.css']
})
export class UploadDataConfirmComponent implements OnInit {

  api_error: any;
  api_success: string;
  acc_id: string;
  statusTo: string;
  disableConfirmbtn = false;
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, private accountService: AccountService,) { }

  ngOnInit() {
    this.acc_id = this.data.account.id;
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onConfirm() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    this.accountService.updateBusinessProfile(this.data.account.id)
    .subscribe(
      data => {
        this.api_success = 'Business Profile Uploaded Successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
      this.disableConfirmbtn = false;
      this.api_error = error.error;
      }
    );

  }
}